import { jsxs, jsx } from 'react/jsx-runtime';
import { LicenseExamStatus, PaymentStatus, WhitelistStatus, ExpungementRequestStatus } from '@snailycad/types';
import { useTranslations } from 'use-intl';

const ConnectionStatus = {
  CONNECTED: "CONNECTED",
  CONNECTING: "CONNECTING",
  DISCONNECTED: "DISCONNECTED"
};
const colors = {
  ACCEPTED: "#3fc89c" /* GREEN */,
  PENDING: "#ffb55b" /* ORANGE */,
  [LicenseExamStatus.PASSED]: "#3fc89c" /* GREEN */,
  [PaymentStatus.PAID]: "#3fc89c" /* GREEN */,
  [ConnectionStatus.CONNECTED]: "#3fc89c" /* GREEN */,
  [LicenseExamStatus.IN_PROGRESS]: "#ffb55b" /* ORANGE */,
  [ConnectionStatus.CONNECTING]: "#ffb55b" /* ORANGE */,
  [WhitelistStatus.DECLINED]: "#ff7b82" /* RED */,
  [ExpungementRequestStatus.DENIED]: "#ff7b82" /* RED */,
  [LicenseExamStatus.FAILED]: "#ff7b82" /* RED */,
  [PaymentStatus.UNPAID]: "#ff7b82" /* RED */,
  [ExpungementRequestStatus.CANCELED]: "#ff7b82" /* RED */,
  [ConnectionStatus.DISCONNECTED]: "#ff7b82" /* RED */
};
function Status({ children, fallback }) {
  const t = useTranslations("Statuses");
  const backgroundColor = children && colors[children];
  return /* @__PURE__ */ jsxs("span", { className: "capitalize", children: [
    backgroundColor ? /* @__PURE__ */ jsx(
      "span",
      {
        style: { background: colors[children] },
        className: "inline-block w-2.5 h-2.5 mr-2 rounded-full"
      }
    ) : null,
    children ? t(children) : fallback ?? ""
  ] });
}

export { ConnectionStatus, Status, colors };
